import { render, staticRenderFns } from "./email-write.vue?vue&type=template&id=63d83e33&scoped=true"
import script from "./email-write.vue?vue&type=script&lang=js"
export * from "./email-write.vue?vue&type=script&lang=js"
import style0 from "./email-write.vue?vue&type=style&index=0&id=63d83e33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d83e33",
  null
  
)

export default component.exports